<template>
    <div>
        <div v-if="show">
            <el-tag style="cursor: pointer;margin:5px" type="warning"  v-for="item in  remarkList" :key="item"
                @click="clickItem(item)"
            >{{ item }}</el-tag> 
        </div>
    </div>
</template>
<script>
    
    export default {
        props:{
            remark:{
                type: String,
                default:'',
            }
        },
        data(){
            return{
                show:false,
                remarkList:[],
            }
        },
        created(){
           
        },
        methods:{
            setRemarkList(data){
               
                // if(typeof data !== 'Array'){
                //     return;
                // }
                this.show = false;
                this.remarkList = data;
                this.show = true
            },
            clickItem(item){
                if(typeof this.remark === 'undefined'){
                    this.remark = item ;
                }else{
                    this.remark = this.remark + item +'   ';;
                    this.$emit("update:remark", this.remark);
                }
                
            }
        },
    }
</script>
